// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Sentry$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/sentry/Sentry.mjs";
import * as PnMHelper$PorterinFeature from "../../domain/helper/PnMHelper.mjs";
import * as PnMStoreEn$PorterinFeature from "../../domain/store/PnMStoreEn.mjs";
import * as PnMFormHelper$PorterinFeature from "../../domain/helper/PnMFormHelper.mjs";
import * as PnMRepoManager$PorterinFeature from "../../domain/repo/PnMRepoManager.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as ErrorUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ErrorUtils.mjs";

function submitLocationDetails(address_info, shift_req_external_id, source, setPreviousResponse, callbacks, onFormSubmitSuccess) {
  var PnMRepoInstance = PnMRepoManager$PorterinFeature.getRepo(undefined);
  Js_promise.$$catch((function (error) {
          Sentry$PorterinUtils.captureException(error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (response) {
              if (response.TAG === /* Ok */0) {
                Curry._1(setPreviousResponse, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: shift_req_external_id
                              };
                      }));
                Curry._1(callbacks.notifyOnSuccess, undefined);
                Curry._1(onFormSubmitSuccess, undefined);
              } else {
                var error = response._0;
                Curry._1(setPreviousResponse, (function (param) {
                        return {
                                TAG: /* Error */1,
                                _0: ErrorUtils$PorterinFusionkitNetworkUtils.resolveError(error)
                              };
                      }));
                Curry._1(callbacks.notifyOnFailure, error);
              }
              return Promise.resolve(undefined);
            }), Curry._3(PnMRepoInstance.submitPnMShiftReqLocationDetails, address_info, shift_req_external_id, source)));
}

function submitBasicDetails(updated_form_data, shifting_type, setPreviousResponse, callbacks, onFormSubmitSuccess) {
  var PnMRepoInstance = PnMRepoManager$PorterinFeature.getRepo(undefined);
  var basic_details = PnMHelper$PorterinFeature.getCustomerShiftReqBasicDetails(updated_form_data, PnMStoreEn$PorterinFeature.default_house_type, PnMStoreEn$PorterinFeature.scf_source_desktop_website, shifting_type);
  var addressInfo_pickup = updated_form_data.pickup;
  var addressInfo_drop = updated_form_data.drop;
  var addressInfo = {
    pickup: addressInfo_pickup,
    drop: addressInfo_drop
  };
  Js_promise.$$catch((function (error) {
          Sentry$PorterinUtils.captureException(error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (response) {
              if (response.TAG === /* Ok */0) {
                submitLocationDetails(addressInfo, response._0.shift_req_external_id, "customer_app_webview", setPreviousResponse, callbacks, onFormSubmitSuccess);
              } else {
                var error = response._0;
                Curry._1(setPreviousResponse, (function (param) {
                        return {
                                TAG: /* Error */1,
                                _0: ErrorUtils$PorterinFusionkitNetworkUtils.resolveError(error)
                              };
                      }));
                Curry._1(callbacks.notifyOnFailure, error);
              }
              return Promise.resolve(undefined);
            }), Curry._2(PnMRepoInstance.submitPnMShiftReqBasicDetails, basic_details, undefined)));
}

function baseFormCallback(updated_form_data, shifting_type, isDesktop, user_city, category, callbacks, setPreviousResponse, onFormSubmitSuccess, query_params) {
  var PnMRepoInstance = PnMRepoManager$PorterinFeature.getRepo(undefined);
  var marketing_params = PnMHelper$PorterinFeature.parseMarketingParams(query_params);
  var lead_data = PnMHelper$PorterinFeature.getCreatePnMLeadData(updated_form_data, isDesktop, shifting_type, marketing_params);
  switch (shifting_type.TAG | 0) {
    case /* Inter */0 :
        PublishEventsHelper$PorterinFeature.publishEvents(PnMHelper$PorterinFeature.getEventCategory(user_city, category), PnMStoreEn$PorterinFeature.ga_action_inter_city_web, PnMHelper$PorterinFeature.getCustomerId(updated_form_data.mobile));
        break;
    case /* Intra */1 :
    case /* Labour */2 :
        break;
    
  }
  Js_promise.$$catch((function (error) {
          Sentry$PorterinUtils.captureException(error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (response) {
              if (response.TAG === /* Ok */0) {
                submitBasicDetails(updated_form_data, shifting_type, setPreviousResponse, callbacks, onFormSubmitSuccess);
              } else {
                var error = response._0;
                Curry._1(setPreviousResponse, (function (param) {
                        return {
                                TAG: /* Error */1,
                                _0: ErrorUtils$PorterinFusionkitNetworkUtils.resolveError(error)
                              };
                      }));
                Curry._1(callbacks.notifyOnFailure, error);
              }
              return Promise.resolve(undefined);
            }), Curry._1(PnMRepoInstance.createPnMOrderInterest, lead_data)));
}

function onFormSubmit(output, callbacks, isDesktop, city_selected_context, setPreviousResponse, onFormSubmitSuccess, show_house_size, query_params, param) {
  var PnMRepoInstance = PnMRepoManager$PorterinFeature.getRepo(undefined);
  var form_data = PnMFormHelper$PorterinFeature.getFormData(output, city_selected_context.city_selected);
  Curry._1(setPreviousResponse, (function (param) {
          
        }));
  Js_promise.$$catch((function (error) {
          Sentry$PorterinUtils.captureException(error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (response) {
              if (response.TAG === /* Ok */0) {
                var shifting_type = response._0;
                Curry._1(setPreviousResponse, (function (param) {
                        
                      }));
                var updated_form_data_name = form_data.name;
                var updated_form_data_mobile = form_data.mobile;
                var updated_form_data_pickup = form_data.pickup;
                var updated_form_data_drop = form_data.drop;
                var updated_form_data_geo_region_id = PnMHelper$PorterinFeature.getGeoregionId(shifting_type);
                var updated_form_data_date = form_data.date;
                var updated_form_data = {
                  name: updated_form_data_name,
                  mobile: updated_form_data_mobile,
                  pickup: updated_form_data_pickup,
                  drop: updated_form_data_drop,
                  geo_region_id: updated_form_data_geo_region_id,
                  date: updated_form_data_date
                };
                PublishEventsHelper$PorterinFeature.publishEvents(PnMHelper$PorterinFeature.getEventCategory(city_selected_context.city_selected, city_selected_context.category), PnMStoreEn$PorterinFeature.pnm_ga_bounds_validate, updated_form_data_mobile);
                PnMHelper$PorterinFeature.publishBaseFormSubmittedGaEvent(updated_form_data, PnMHelper$PorterinFeature.getEventCategory(city_selected_context.city_selected, city_selected_context.category), shifting_type);
                PnMHelper$PorterinFeature.publishHouseSizeGaEvent(show_house_size, output.house);
                baseFormCallback(updated_form_data, shifting_type, isDesktop, city_selected_context.city_selected, city_selected_context.category, callbacks, setPreviousResponse, onFormSubmitSuccess, query_params);
              } else {
                var error = response._0;
                Curry._1(setPreviousResponse, (function (param) {
                        return {
                                TAG: /* Error */1,
                                _0: ErrorUtils$PorterinFusionkitNetworkUtils.resolveError(error)
                              };
                      }));
                Curry._1(callbacks.notifyOnFailure, error);
              }
              return Promise.resolve(undefined);
            }), Curry._4(PnMRepoInstance.validateGeoregion, output.pickup, output.drop, output.mobile, "Pnm")));
}

export {
  submitLocationDetails ,
  submitBasicDetails ,
  baseFormCallback ,
  onFormSubmit ,
}
/* Sentry-PorterinUtils Not a pure module */
